import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getColor } from "utils/colors";

const getRows = (data) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        tipoResiduo: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.tipoResiduo}
            </SoftTypography>
          </SoftBox>
        ),
        descripcionResiduo: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.descripcionResiduo}
            </SoftTypography>
          </SoftBox>
        ),
        cantidadResiduo: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.cantidadResiduo}
            </SoftTypography>
          </SoftBox>
        ),
        estadoFisico: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.estadoFisico}
            </SoftTypography>
          </SoftBox>
        ),
        descripcionTransporteAuditoria: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.descripcionTransporteAuditoria}
            </SoftTypography>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "tipoResiduo", desc: "Tipo de Residuo", align: "center", noOrder: true, width: "1%" },
  { name: "cantidadResiduo", desc: "Cantidad", align: "left", noOrder: true },
  { name: "descripcionResiduo", desc: "Descripción del Residuo", align: "left", noOrder: true },
  { name: "estadoFisico", desc: "Estado", align: "left", noOrder: true },
  {
    name: "descripcionTransporteAuditoria",
    desc: "Transporte y Auditoría",
    align: "left",
    noOrder: true,
  },
];

export default { columns, getRows };
